<template>
  <v-snackbar :color="color" :timeout="timer" v-model="showSnackbar" top right rounded="pill">
    <v-icon left>{{icon}}</v-icon>{{message}}
  </v-snackbar>
</template>

<script>
export default {
  name: "successSnackbar",
  data() {
    return{
      showSnackbar: false,
      message: '',
      color: 'error',
      icon: 'mdi-check',
      timer: 3000
    }
  },
  methods:{
    show(data = {}) {
      this.message = data.message || 'missing "message".'
      this.color = data.color || 'error'
      this.timer = data.timer || 3000
      this.icon = data.icon || 'mdi-close'
      this.showSnackbar = true
    }
  }
}
</script>